import { Component } from '@angular/core';

@Component({
  selector: 'lib-posting-skeleton',
  templateUrl: './posting-skeleton.component.html',
  styleUrls: ['./posting-skeleton.component.scss'],
  standalone: true
})
export class PostingSkeletonComponent {

  constructor() { }

}
